import React from 'react';
import {connect} from 'react-redux';
import PulseLoader from 'react-spinners/PulseLoader'
const WIDTH = 390;

const ProgressBar = ({loadingProgress, width=WIDTH}) => {
    let style = {
        width: width * loadingProgress / 100.0
    };
    return (
        <div className="progress-bar">
          <div className="inner-progress-bar">
          <div className="progress" style={style}/>
            <div className="loading-text">
              Loading Project ...
            </div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, {sequencerEngine, id})=> {
    return {
        loadingProgress: state.sequencer.sequenceLoadingProgress[id || sequencerEngine.sequenceId] || 0
    };
};


export default connect(mapStateToProps, null)(ProgressBar);
